import product1 from "../assets/images/products/product1.png";
import product2 from "../assets/images/products/product2.png";
import product3 from "../assets/images/products/product3.png";
import product4 from "../assets/images/products/product4.png";
import product5 from "../assets/images/products/product 4.png";
import product6 from "../assets/images/products/product 5.png";
import product7 from "../assets/images/products/product 6.png";
import product8 from "../assets/images/products/product 7.png";
import product9 from "../assets/images/products/product 8.png";
import product10 from "../assets/images/products/product 9.png";
import product11 from "../assets/images/products/product 10.png";
import product12 from "../assets/images/products/product 11.png";
import product13 from "../assets/images/products/product 62.png";
import product14 from "../assets/images/products/product 68.png";
import product15 from "../assets/images/products/product 69.png";
import product16 from "../assets/images/products/product 70.png";
import product17 from "../assets/images/products/product 71.png";
import sarong24 from "../assets/images/sarong 24.png";
import sarong26 from "../assets/images/sarong 26.png";
import sarong27 from "../assets/images/sarong 27.png";
import sarong28 from "../assets/images/sarong 28.png";
import sarong29 from "../assets/images/sarong 29.png";
import sarong30 from "../assets/images/sarong 30.png";
import sarong31 from "../assets/images/sarong 31.png";
import sarong32 from "../assets/images/sarong 32.png";
import sarong33 from "../assets/images/sarong 33.png";
import sarong34 from "../assets/images/sarong 34.png";
import sarong35 from "../assets/images/sarong 35.png";
import sarong36 from "../assets/images/sarong 36.png";
import yasin37 from "../assets/images/yasin 37.png";
import yasin38 from "../assets/images/yasin 38.png";
import yasin39 from "../assets/images/yasin 39.png";
import yasin40 from "../assets/images/yasin 40.png";
import yasin41 from "../assets/images/yasin 41.png";
import yasin42 from "../assets/images/yasin 42.png";
import yasin43 from "../assets/images/yasin 43.png";
import yasin44 from "../assets/images/yasin 44.png";
import yasin45 from "../assets/images/yasin 45.png";
import yasin46 from "../assets/images/yasin 46.png";
import yasin47 from "../assets/images/yasin 47.png";
import yasin48 from "../assets/images/yasin 48.png";
import tasbih49 from "../assets/images/tasbih 49.png";
import tasbih50 from "../assets/images/tasbih 50.png";
import tasbih51 from "../assets/images/tasbih 51.png";
import tasbih52 from "../assets/images/tasbih 52.png";
import tasbih53 from "../assets/images/tasbih 53.png";
import tasbih54 from "../assets/images/tasbih 54.png";
import tasbih55 from "../assets/images/tasbih 55.png";
import tasbih56 from "../assets/images/tasbih 56.png";
import tasbih57 from "../assets/images/tasbih 57.png";
import tasbih58 from "../assets/images/tasbih 58.png";
import tasbih59 from "../assets/images/tasbih 59.png";
import tasbih60 from "../assets/images/tasbih 60.png";
import sajadah1 from "../assets/images/image 12.png";
import sajadah2 from "../assets/images/image 13.png";
import sajadah3 from "../assets/images/image 14.png";
import sajadah4 from "../assets/images/image 15.png";
import sajadah5 from "../assets/images/image 16.png";
import sajadah6 from "../assets/images/image 17.png";
import sajadah7 from "../assets/images/image 18.png";
import sajadah8 from "../assets/images/image 19.png";
import sajadah9 from "../assets/images/image 20.png";
import sajadah10 from "../assets/images/image 21.png";

export const products = [
  {
    slug: "alimama-hyget-mukena-free-bag",
    title: "AliMaMa - HYGET MUKENA - FREE BAG",
    price: "RM150",
    location: "Kuala Lumpur",
    image: product5,
    gallery: [product5, product2, product3, product1],
    description: [
      "Mukena with Free Mini Pouch. Without prayer mat. The prayer-mat set is available in our storefront.",
      "The Syahria 2-in-1 Travel Mukena (Poncho Style) comes with dual functionality. There is a zipper at the chin area, allowing the headpiece to be removed—so you can wear a hijab underneath without taking off the entire mukena.",
      "This Syahria mukena includes a small rectangular pouch with a zipper—simple, elegant, and perfect for traveling or bringing to the office.",
      "Syahria travel mukena is very comfortable and cooling for daily use, made from premium cotton material.",
    ],
    detail: [
      "Material: Premium cotton",
      "Cutting: Poncho style with chin zipper",
      "Included: Rectangular pouch with zipper",
      "Prayer mat: Not included (available separately)",
    ],
    minimumOrder: "Minimum Order: 1 Piece",
    notes:
      "Slight color differences may occur due to variations in lighting between camera capture and your phone screen. However, we ensure the product color closely matches the photos.",
  },
  {
    slug: "mukena-traveling-mini-petunia",
    title: "Mukena Traveling Mini Terkecil - Petunia (Case Polos) Atas Bawah",
    price: "RM98",
    location: "Melaka",
    image: product6,
    gallery: [product6, product1, product3, product4],
    description: [
      "Compact travel mukena designed to fit in a mini case, ideal for on-the-go worship.",
      "Made with lightweight, breathable fabric to keep you comfortable in any climate.",
    ],
    detail: [
      "Mini travel case included",
      "Easy-care fabric, machine washable",
      "Breathable and lightweight",
    ],
    minimumOrder: "Minimum Order: 1 Set",
    notes: "Colors may appear slightly different depending on lighting and screen settings.",
  },
  {
    slug: "alimama-hyget-mukena-mint",
    title: "AliMaMa - MUKENA HYGET - GRATIS TAS Mukenah Traveling Renda Amplop (Mint)",
    price: "RM150",
    location: "Johor",
    image: product7,
    gallery: [product7, product2, product1],
    description: [
      "Elegant mukena with lace envelope bag for easy carrying.",
      "Soft material with cooling sensation, suitable for long prayers.",
    ],
    detail: [
      "Included lace envelope bag",
      "Soft, cooling fabric",
      "Breathable and flowy cut",
    ],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Color tones stay true to photos, minor variance may occur on different screens.",
  },
  {
    slug: "alimama-hyget-mukena-black",
    title: "AliMaMa - MUKENA HYGET - GRATIS TAS Mukenah Traveling Renda Amplop (Black)",
    price: "RM150",
    location: "Kuala Lumpur",
    image: product8,
    gallery: [product8, product4, product2],
    description: [
      "Classic black mukena with free lace travel bag.",
      "Designed for comfort and modest coverage during prayer.",
    ],
    detail: [
      "Lace travel bag included",
      "Durable and soft fabric blend",
      "Machine washable",
    ],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Slight variance in color due to lighting is normal.",
  },
  {
    slug: "mukena-traveling-mini-sarawak",
    title: "Mukena Traveling Mini Terkecil - Case Polos (Sarawak)",
    price: "RM98",
    location: "Sarawak",
    image: product9,
    gallery: [product9, product3, product4],
    description: [
      "Ultra-compact mukena with minimalist case for easy packing.",
      "Lightweight material keeps you cool for daily use.",
    ],
    detail: [
      "Minimalist travel case",
      "Cooling, quick-dry fabric",
      "Compact folding design",
    ],
    minimumOrder: "Minimum Order: 1 Set",
    notes: "Minor color differences may appear on various screens.",
  },
  {
    slug: "mukena-exclusive-collaboration",
    title: "Mukena Exclusive Collaboration",
    price: "RM150",
    location: "Penang",
    image: product10,
    gallery: [product10, product1, product2],
    description: [
      "Signature collaboration piece with elegant print and soft texture.",
      "Comes with matching pouch for convenient travel.",
    ],
    detail: [
      "Matching printed pouch",
      "Soft-touch material",
      "Relaxed, airy fit",
    ],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Product colors remain close to reference photos.",
  },
  {
    slug: "mukena-basic-set",
    title: "Mukena Basic Travel Set",
    price: "RM120",
    location: "Selangor",
    image: product11,
    gallery: [product11, product1, product2],
    description: [
      "Everyday mukena set built for daily prayers and travel readiness.",
      "Includes a practical pouch for easy storage.",
    ],
    detail: [
      "Travel pouch included",
      "Breathable cotton blend",
      "Easy maintenance",
    ],
    minimumOrder: "Minimum Order: 1 Set",
    notes: "Slight color variation may occur across devices.",
  },
  {
    slug: "mukena-classic-soft",
    title: "Mukena Classic Soft Collection",
    price: "RM130",
    location: "Kuala Lumpur",
    image: product12,
    gallery: [product12, product2, product3],
    description: [
      "Soft-touch classic mukena designed for comfort and modesty.",
      "Ideal for both home prayers and travel.",
    ],
    detail: [
      "Soft-touch fabric",
      "Classic drape for full coverage",
      "Travel-friendly pouch",
    ],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Colors remain accurate, with minor differences possible due to lighting.",
  },
  {
    slug: "alimama-hyget-mukena-brown",
    title: "AliMaMa - HYGET MUKENA - Envelope Bag (Brown)",
    price: "RM150",
    location: "Kuala Lumpur",
    image: product13,
    gallery: [product13, product1, product2],
    description: ["Elegant brown mukena with envelope lace bag for daily prayers."],
    detail: ["Lace envelope bag", "Cooling fabric", "Easy care"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Colors may vary slightly.",
  },
  {
    slug: "travel-mukena-blue",
    title: "Mukena Traveling Mini - Blue Case",
    price: "RM98",
    location: "Kuala Lumpur",
    image: product14,
    gallery: [product14, product3, product4],
    description: ["Compact mukena with blue minimalist travel case."],
    detail: ["Mini case included", "Lightweight fabric", "Quick dry"],
    minimumOrder: "Minimum Order: 1 Set",
    notes: "Minor color difference possible on screens.",
  },
  {
    slug: "travel-mukena-pink",
    title: "Mukena Traveling Mini - Pink Case",
    price: "RM98",
    location: "Kuala Lumpur",
    image: product15,
    gallery: [product15, product1, product3],
    description: ["Travel-ready mukena in pink case for easy packing."],
    detail: ["Mini case included", "Breathable fabric", "Machine washable"],
    minimumOrder: "Minimum Order: 1 Set",
    notes: "Slight color variance may occur.",
  },
  {
    slug: "alimama-hyget-mukena-grey",
    title: "AliMaMa - MUKENA HYGET - Lace Travel Bag (Grey)",
    price: "RM150",
    location: "Kuala Lumpur",
    image: product16,
    gallery: [product16, product2, product4],
    description: ["Grey variant with lace travel bag, soft-touch material."],
    detail: ["Lace bag included", "Soft cooling fabric", "Flowy cut"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Color tone may differ slightly due to lighting.",
  },
  {
    slug: "alimama-hyget-mukena-beige",
    title: "AliMaMa - HYGET MUKENA - FREE BAG (Beige)",
    price: "RM150",
    location: "Kuala Lumpur",
    image: product17,
    gallery: [product17, product2, product1],
    description: ["Beige poncho-style mukena with detachable chin zipper."],
    detail: ["Zippered chin", "Free pouch", "Premium cotton feel"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Minor color differences may appear on screens.",
  },
  {
    slug: "mukena-collab-limited",
    title: "Mukena Limited Collaboration Edition",
    price: "RM150",
    location: "Kuala Lumpur",
    image: product3,
    gallery: [product3, product1, product2],
    description: ["Limited collab mukena with exclusive pattern and soft fabric."],
    detail: ["Matching pouch", "Soft-touch material", "Relaxed fit"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Colors stay close to photos.",
  },
  {
    slug: "mukena-basic-grey",
    title: "Mukena Basic Travel Set (Grey)",
    price: "RM120",
    location: "Kuala Lumpur",
    image: product1,
    gallery: [product1, product2, product4],
    description: ["Practical grey travel set with airy material."],
    detail: ["Travel pouch", "Breathable cotton blend", "Easy maintenance"],
    minimumOrder: "Minimum Order: 1 Set",
    notes: "Minor tone differences may appear.",
  },
  {
    slug: "mukena-soft-pastel",
    title: "Mukena Soft Pastel Series",
    price: "RM130",
    location: "Kuala Lumpur",
    image: product2,
    gallery: [product2, product3, product4],
    description: ["Pastel series mukena with cooling fabric, ideal for travel."],
    detail: ["Includes pouch", "Cooling fabric", "Lightweight"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Colors may vary slightly per screen.",
  },
  {
    slug: "mukena-airy-blue",
    title: "Mukena Airy Series - Blue",
    price: "RM120",
    location: "Kuala Lumpur",
    image: product3,
    gallery: [product3, product1, product2],
    description: ["Airy blue mukena with breathable weave for comfort."],
    detail: ["Airy weave", "Quick dry", "Travel-friendly pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Minor color differences possible.",
  },
  {
    slug: "mukena-airy-green",
    title: "Mukena Airy Series - Green",
    price: "RM120",
    location: "Kuala Lumpur",
    image: product4,
    gallery: [product4, product2, product3],
    description: ["Green airy series with cooling fabric and pouch."],
    detail: ["Cooling fabric", "Lightweight", "Includes pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Slight color variation may occur.",
  },
  {
    slug: "mukena-travel-olive",
    title: "Mukena Traveling Set - Olive",
    price: "RM110",
    location: "Kuala Lumpur",
    image: product2,
    gallery: [product2, product1, product3],
    description: ["Olive travel mukena with compact storage bag."],
    detail: ["Compact bag", "Soft fabric", "Quick dry"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Colors may vary slightly.",
  },
  {
    slug: "mukena-travel-soft-pink",
    title: "Mukena Traveling Set - Soft Pink",
    price: "RM110",
    location: "Kuala Lumpur",
    image: product1,
    gallery: [product1, product4, product2],
    description: ["Soft pink travel mukena with elegant drape."],
    detail: ["Travel pouch", "Soft drape", "Lightweight"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Minor color differences may occur.",
  },
  {
    slug: "mukena-comfort-grey",
    title: "Mukena Comfort Series - Grey",
    price: "RM125",
    location: "Kuala Lumpur",
    image: product3,
    gallery: [product3, product2, product4],
    description: ["Comfort series mukena with breathable, cooling fabric."],
    detail: ["Cooling fabric", "Breathable weave", "Travel pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Slight tone variation may appear.",
  },
  {
    slug: "mukena-comfort-beige",
    title: "Mukena Comfort Series - Beige",
    price: "RM125",
    location: "Kuala Lumpur",
    image: product4,
    gallery: [product4, product1, product2],
    description: ["Beige comfort series with premium cotton feel."],
    detail: ["Premium cotton feel", "Soft drape", "Travel pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Colors remain close to photos.",
  },
  {
    slug: "sarong-soft-beige",
    title: "Sarong Soft Beige Set",
    price: "RM85",
    location: "Kuala Lumpur",
    image: sarong24,
    gallery: [sarong24, sarong29, sarong31],
    description: ["Sarong warna beige dengan material lembut dan nyaman dipakai harian."],
    detail: ["Soft cotton blend", "Breathable", "Include matching pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna mungkin sedikit berbeda di layar perangkat.",
    category: "sarong",
  },
  {
    slug: "sarong-classic-black",
    title: "Sarong Classic Black",
    price: "RM90",
    location: "Selangor",
    image: sarong26,
    gallery: [sarong26, sarong27, sarong29],
    description: ["Sarong hitam klasik dengan aksen list elegan, ringan dan tidak menerawang."],
    detail: ["Lightweight", "Non-see-through", "Easy care"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Sedikit perbedaan tone dapat terjadi.",
    category: "sarong",
  },
  {
    slug: "sarong-silver-grey",
    title: "Sarong Silver Grey",
    price: "RM92",
    location: "Johor",
    image: sarong27,
    gallery: [sarong27, sarong24, sarong30],
    description: ["Sarong grey lembut dengan tampilan modern dan jatuh yang rapi."],
    detail: ["Soft drape", "Cool touch", "Comes with pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Tone warna dapat sedikit bervariasi.",
    category: "sarong",
  },
  {
    slug: "sarong-maroon-luxe",
    title: "Sarong Maroon Luxe",
    price: "RM94",
    location: "Penang",
    image: sarong28,
    gallery: [sarong28, sarong26, sarong33],
    description: ["Sarong maroon dengan detail lembut, cocok untuk tampilan elegan."],
    detail: ["Soft drape", "Breathable", "Include pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna bisa berbeda sedikit akibat pencahayaan.",
    category: "sarong",
  },
  {
    slug: "sarong-emerald-green",
    title: "Sarong Emerald Green",
    price: "RM92",
    location: "Penang",
    image: sarong29,
    gallery: [sarong29, sarong27, sarong30],
    description: ["Sarong hijau emerald dengan trimming lembut, cocok untuk hadiah."],
    detail: ["Soft handfeel", "Breathable", "Lightweight"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna bisa berbeda sedikit akibat pencahayaan.",
    category: "sarong",
  },
  {
    slug: "sarong-sky-blue",
    title: "Sarong Sky Blue",
    price: "RM95",
    location: "Melaka",
    image: sarong30,
    gallery: [sarong30, sarong24, sarong29],
    description: ["Sarong warna biru cerah dengan bahan ringan dan cepat kering."],
    detail: ["Quick dry", "Lightweight", "Include pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Sedikit perbedaan warna mungkin terjadi.",
    category: "sarong",
  },
  {
    slug: "sarong-rose-pink",
    title: "Sarong Rose Pink",
    price: "RM95",
    location: "Kuala Lumpur",
    image: sarong31,
    gallery: [sarong31, sarong34, sarong36],
    description: ["Sarong warna rose pink lembut, jatuh rapi dan nyaman dipakai."],
    detail: ["Soft drape", "Breathable", "Easy care"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Perbedaan warna tipis dapat muncul di layar.",
    category: "sarong",
  },
  {
    slug: "sarong-terracotta",
    title: "Sarong Terracotta",
    price: "RM96",
    location: "Johor",
    image: sarong32,
    gallery: [sarong32, sarong29, sarong24],
    description: ["Sarong warna terracotta hangat dengan tekstur lembut."],
    detail: ["Soft touch", "Breathable", "Includes pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Tone warna dapat sedikit bervariasi.",
    category: "sarong",
  },
  {
    slug: "sarong-ash-blue",
    title: "Sarong Ash Blue",
    price: "RM96",
    location: "Sarawak",
    image: sarong33,
    gallery: [sarong33, sarong30, sarong27],
    description: ["Sarong ash blue dengan tampilan modern dan ringan."],
    detail: ["Lightweight", "Soft drape", "Easy care"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna mungkin sedikit berbeda di layar perangkat.",
    category: "sarong",
  },
  {
    slug: "sarong-coral",
    title: "Sarong Coral",
    price: "RM95",
    location: "Penang",
    image: sarong34,
    gallery: [sarong34, sarong31, sarong32],
    description: ["Sarong warna coral yang lembut dengan bahan adem."],
    detail: ["Cool touch", "Breathable", "Include pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Sedikit perbedaan warna mungkin terjadi.",
    category: "sarong",
  },
  {
    slug: "sarong-mint",
    title: "Sarong Mint",
    price: "RM94",
    location: "Selangor",
    image: sarong35,
    gallery: [sarong35, sarong24, sarong33],
    description: ["Sarong warna mint segar dengan jatuh rapi dan ringan."],
    detail: ["Soft drape", "Lightweight", "Easy care"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Perbedaan warna tipis dapat muncul di layar.",
    category: "sarong",
  },
  {
    slug: "sarong-lilac",
    title: "Sarong Lilac",
    price: "RM95",
    location: "Kuala Lumpur",
    image: sarong36,
    gallery: [sarong36, sarong31, sarong35],
    description: ["Sarong warna lilac lembut, nyaman untuk penggunaan harian."],
    detail: ["Soft touch", "Breathable", "Include pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna mungkin sedikit berbeda di layar perangkat.",
    category: "sarong",
  },
  {
    slug: "yasin-emboss-gold",
    title: "Yasin Emboss Gold",
    price: "RM12",
    location: "Kuala Lumpur",
    image: yasin37,
    gallery: [yasin37, yasin38, yasin39],
    description: ["Buku Yasin dengan emboss emas elegan, cocok untuk majlis doa."],
    detail: ["Emboss gold", "Kertas tebal", "Finishing premium"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna bisa sedikit berbeda di layar.",
    category: "yasin",
  },
  {
    slug: "yasin-soft-blue",
    title: "Yasin Soft Blue",
    price: "RM11",
    location: "Selangor",
    image: yasin38,
    gallery: [yasin38, yasin40, yasin41],
    description: ["Cover biru lembut dengan huruf arab jelas dan kertas berkualitas."],
    detail: ["Soft cover", "Cetakan jelas", "Ukuran saku"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Tone warna dapat sedikit bervariasi.",
    category: "yasin",
  },
  {
    slug: "yasin-classic-brown",
    title: "Yasin Classic Brown",
    price: "RM11",
    location: "Johor",
    image: yasin39,
    gallery: [yasin39, yasin37, yasin45],
    description: ["Nuansa coklat klasik dengan emboss kaligrafi minimalis."],
    detail: ["Emboss kaligrafi", "Kertas tebal", "Binding kuat"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna mungkin sedikit berbeda karena pencahayaan.",
    category: "yasin",
  },
  {
    slug: "yasin-mint",
    title: "Yasin Mint Series",
    price: "RM10",
    location: "Penang",
    image: yasin40,
    gallery: [yasin40, yasin41, yasin44],
    description: ["Cover warna mint segar dengan aksen minimalis."],
    detail: ["Soft touch cover", "Cetak tajam", "Ukuran ringkas"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Perbedaan warna tipis dapat muncul di layar.",
    category: "yasin",
  },
  {
    slug: "yasin-grey",
    title: "Yasin Grey Minimal",
    price: "RM10",
    location: "Melaka",
    image: yasin41,
    gallery: [yasin41, yasin37, yasin46],
    description: ["Cover grey dengan desain minimal, cocok untuk paket tahlil."],
    detail: ["Minimal design", "Kertas halus", "Cetakan jelas"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Tone warna mungkin berbeda sedikit.",
    category: "yasin",
  },
  {
    slug: "yasin-dark-navy",
    title: "Yasin Dark Navy",
    price: "RM12",
    location: "Kuala Lumpur",
    image: yasin42,
    gallery: [yasin42, yasin44, yasin40],
    description: ["Cover navy dengan detail gold, tampilan elegan."],
    detail: ["Gold detail", "Binding kuat", "Kertas berkualitas"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna bisa sedikit berbeda di layar.",
    category: "yasin",
  },
  {
    slug: "yasin-cream",
    title: "Yasin Cream Series",
    price: "RM10",
    location: "Selangor",
    image: yasin43,
    gallery: [yasin43, yasin41, yasin45],
    description: ["Cover krem lembut dengan emboss sederhana."],
    detail: ["Emboss sederhana", "Kertas tebal", "Ukuran praktis"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Perbedaan tone warna kecil mungkin terjadi.",
    category: "yasin",
  },
  {
    slug: "yasin-blue-gold",
    title: "Yasin Blue Gold",
    price: "RM12",
    location: "Johor",
    image: yasin44,
    gallery: [yasin44, yasin42, yasin38],
    description: ["Kombinasi biru dan emas dengan kesan premium."],
    detail: ["Foil gold", "Cetak jelas", "Binding rapih"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna dapat sedikit berbeda pada layar.",
    category: "yasin",
  },
  {
    slug: "yasin-dark-maron",
    title: "Yasin Dark Maroon",
    price: "RM12",
    location: "Penang",
    image: yasin45,
    gallery: [yasin45, yasin38, yasin41],
    description: ["Cover maroon gelap dengan detail emboss premium."],
    detail: ["Emboss premium", "Kertas tebal", "Ukuran compact"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Perbedaan warna tipis mungkin muncul.",
    category: "yasin",
  },
  {
    slug: "yasin-light-blue",
    title: "Yasin Light Blue",
    price: "RM10",
    location: "Sarawak",
    image: yasin46,
    gallery: [yasin46, yasin40, yasin42],
    description: ["Cover biru muda dengan nuansa tenang dan minimalis."],
    detail: ["Soft cover", "Cetak tajam", "Binding kuat"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna mungkin sedikit berbeda di layar.",
    category: "yasin",
  },
  {
    slug: "yasin-brown-gold",
    title: "Yasin Brown Gold",
    price: "RM11",
    location: "Selangor",
    image: yasin47,
    gallery: [yasin47, yasin45, yasin39],
    description: ["Cover coklat dengan detail gold yang anggun."],
    detail: ["Foil gold", "Kertas premium", "Ukuran ringkas"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Perbedaan warna tipis dapat terjadi.",
    category: "yasin",
  },
  {
    slug: "yasin-grey-emboss",
    title: "Yasin Grey Emboss",
    price: "RM11",
    location: "Kuala Lumpur",
    image: yasin48,
    gallery: [yasin48, yasin37, yasin44],
    description: ["Cover abu dengan emboss kaligrafi dan tekstur halus."],
    detail: ["Emboss kaligrafi", "Kertas tebal", "Binding kuat"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna bisa sedikit berbeda di layar.",
    category: "yasin",
  },
  {
    slug: "tasbih-kayu-polished",
    title: "Tasbih Kayu Polished",
    price: "RM15",
    location: "Kuala Lumpur",
    image: tasbih49,
    gallery: [tasbih49, tasbih50, tasbih51],
    description: ["Tasbih kayu dengan finishing polished, ringan dan nyaman di tangan."],
    detail: ["Material kayu", "Bentuk ergonomic", "Ringan dibawa"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna kayu bisa sedikit berbeda alami.",
    category: "tasbih",
  },
  {
    slug: "tasbih-batu-hitam",
    title: "Tasbih Batu Hitam",
    price: "RM18",
    location: "Selangor",
    image: tasbih50,
    gallery: [tasbih50, tasbih52, tasbih53],
    description: ["Tasbih batu hitam glossy dengan aksen tassel elegan."],
    detail: ["Material batu", "Glossy finish", "Tassel kain"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Variasi warna batu mungkin terjadi.",
    category: "tasbih",
  },
  {
    slug: "tasbih-amber",
    title: "Tasbih Amber Series",
    price: "RM17",
    location: "Johor",
    image: tasbih51,
    gallery: [tasbih51, tasbih54, tasbih55],
    description: ["Butiran amber hangat dengan kilau lembut dan sentuhan klasik."],
    detail: ["Amber beads", "Tassel klasik", "Ringan digunakan"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Perbedaan tone warna alami dapat terjadi.",
    category: "tasbih",
  },
  {
    slug: "tasbih-kristal-biru",
    title: "Tasbih Kristal Biru",
    price: "RM19",
    location: "Penang",
    image: tasbih52,
    gallery: [tasbih52, tasbih50, tasbih59],
    description: ["Tasbih kristal biru transparan dengan kilau elegan."],
    detail: ["Kristal transparan", "Aksen tassel", "Feel sejuk di tangan"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Kilau kristal mungkin berbeda sesuai pencahayaan.",
    category: "tasbih",
  },
  {
    slug: "tasbih-kristal-multicolor",
    title: "Tasbih Kristal Multicolor",
    price: "RM20",
    location: "Melaka",
    image: tasbih53,
    gallery: [tasbih53, tasbih52, tasbih50],
    description: ["Tasbih kristal warna-warni dengan tassel lembut."],
    detail: ["Multi color beads", "Tassel lembut", "Glossy finish"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Urutan warna dapat sedikit berbeda.",
    category: "tasbih",
  },
  {
    slug: "tasbih-wooden-classic",
    title: "Tasbih Wooden Classic",
    price: "RM16",
    location: "Sarawak",
    image: tasbih54,
    gallery: [tasbih54, tasbih49, tasbih55],
    description: ["Tasbih kayu klasik dengan butiran halus dan ringan."],
    detail: ["Halus di tangan", "Ringan", "Tassel kain"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Grain kayu alami bisa berbeda.",
    category: "tasbih",
  },
  {
    slug: "tasbih-batu-brown",
    title: "Tasbih Batu Brown",
    price: "RM18",
    location: "Penang",
    image: tasbih55,
    gallery: [tasbih55, tasbih54, tasbih51],
    description: ["Tasbih batu bernuansa coklat dengan finishing halus."],
    detail: ["Batu halus", "Tassel elegan", "Durable"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Warna batu dapat bervariasi.",
    category: "tasbih",
  },
  {
    slug: "tasbih-kristal-clear",
    title: "Tasbih Kristal Clear",
    price: "RM19",
    location: "Selangor",
    image: tasbih56,
    gallery: [tasbih56, tasbih52, tasbih53],
    description: ["Kristal bening yang memancarkan kesan bersih dan elegan."],
    detail: ["Crystal clear", "Glossy beads", "Tassel lembut"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Kilau bisa berbeda karena cahaya.",
    category: "tasbih",
  },
  {
    slug: "tasbih-kayu-dark",
    title: "Tasbih Kayu Dark",
    price: "RM16",
    location: "Johor",
    image: tasbih57,
    gallery: [tasbih57, tasbih49, tasbih50],
    description: ["Kayu dark tone dengan tekstur halus dan tassel serasi."],
    detail: ["Kayu dark", "Ringan", "Tassel kain"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Serat kayu bisa berbeda-beda.",
    category: "tasbih",
  },
  {
    slug: "tasbih-amber-mix",
    title: "Tasbih Amber Mix",
    price: "RM18",
    location: "Kuala Lumpur",
    image: tasbih58,
    gallery: [tasbih58, tasbih53, tasbih52],
    description: ["Campuran amber dengan warna hangat dan kilau lembut."],
    detail: ["Mix amber beads", "Soft tassel", "Feel nyaman"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Komposisi warna dapat berbeda antar batch.",
    category: "tasbih",
  },
  {
    slug: "tasbih-blue-ombre",
    title: "Tasbih Blue Ombre",
    price: "RM19",
    location: "Melaka",
    image: tasbih59,
    gallery: [tasbih59, tasbih52, tasbih50],
    description: ["Gradasi biru ombre dengan butiran kristal elegan."],
    detail: ["Ombre beads", "Glossy finish", "Tassel kain"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Gradasi bisa sedikit berbeda.",
    category: "tasbih",
  },
  {
    slug: "tasbih-emerald",
    title: "Tasbih Emerald",
    price: "RM18",
    location: "Sarawak",
    image: tasbih60,
    gallery: [tasbih60, tasbih51, tasbih54],
    description: ["Tasbih hijau emerald dengan kesan menenangkan dan elegan."],
    detail: ["Emerald beads", "Soft tassel", "Ringan"],
    minimumOrder: "Minimum Order: 10 pcs",
    notes: "Tone warna bisa berbeda karena cahaya.",
    category: "tasbih",
  },
  {
    slug: "sajadah-travel-lightweight",
    title: "Sajadah Travel Lightweight",
    price: "RM80",
    location: "Selangor",
    image: sajadah1,
    gallery: [sajadah1, sajadah5, sajadah6],
    description: ["Ringan, anti-slip, mudah dilipat untuk dibawa ke mana saja."],
    detail: ["Anti-slip base", "Quick dry surface", "Compact fold"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Tone warna mungkin sedikit berbeda akibat pencahayaan.",
    category: "sajadah",
  },
  {
    slug: "sajadah-plush-comfort",
    title: "Sajadah Plush Comfort",
    price: "RM95",
    location: "Kuala Lumpur",
    image: sajadah2,
    gallery: [sajadah2, sajadah1, sajadah5],
    description: ["Sajadah tebal dan empuk dengan serat lembut untuk kenyamanan sujud."],
    detail: ["Plush microfiber", "Non-slip backing", "Machine washable"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Sedikit perbedaan warna dapat terjadi karena layar perangkat.",
    category: "sajadah",
  },
  {
    slug: "sajadah-premium-velvet",
    title: "Sajadah Premium Velvet",
    price: "RM110",
    location: "Johor",
    image: sajadah3,
    gallery: [sajadah3, sajadah7, sajadah8],
    description: ["Finishing velvet premium dengan bordir elegan, cocok untuk hadiah."],
    detail: ["Velvet surface", "Embroidered edges", "Travel pouch included"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna tetap mendekati foto referensi.",
    category: "sajadah",
  },
  {
    slug: "sajadah-anti-slip-compact",
    title: "Sajadah Anti-Slip Compact",
    price: "RM85",
    location: "Penang",
    image: sajadah4,
    gallery: [sajadah4, sajadah1, sajadah6],
    description: ["Desain compact dengan lapisan anti-slip, ideal untuk perjalanan."],
    detail: ["Anti-slip bottom", "Lightweight", "Comes with elastic strap"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Terdapat perbedaan warna tipis karena pencahayaan.",
    category: "sajadah",
  },
  {
    slug: "sajadah-memory-foam",
    title: "Sajadah Memory Foam",
    price: "RM120",
    location: "Kuala Lumpur",
    image: sajadah5,
    gallery: [sajadah5, sajadah3, sajadah7],
    description: ["Lapisan memory foam untuk kenyamanan ekstra saat sholat."],
    detail: ["Memory foam core", "Soft knit top", "Anti-slip base"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Variasi warna tipis mungkin terjadi.",
    category: "sajadah",
  },
  {
    slug: "sajadah-eco-weave",
    title: "Sajadah Eco Weave",
    price: "RM90",
    location: "Melaka",
    image: sajadah6,
    gallery: [sajadah6, sajadah2, sajadah4],
    description: ["Anyaman ramah lingkungan dengan tekstur lembut dan breathable."],
    detail: ["Eco-friendly fibers", "Breathable weave", "Lightweight"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna dapat berbeda sedikit pada setiap layar.",
    category: "sajadah",
  },
  {
    slug: "sajadah-foldable-zip",
    title: "Sajadah Foldable Zip",
    price: "RM88",
    location: "Sarawak",
    image: sajadah7,
    gallery: [sajadah7, sajadah1, sajadah6],
    description: ["Sajadah lipat dengan tas zip built-in, mudah disimpan."],
    detail: ["Built-in zip pouch", "Quick dry", "Anti-slip dots"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Perbedaan warna ringan dapat terjadi.",
    category: "sajadah",
  },
  {
    slug: "sajadah-kids-soft",
    title: "Sajadah Kids Soft Series",
    price: "RM70",
    location: "Selangor",
    image: sajadah8,
    gallery: [sajadah8, sajadah2, sajadah4],
    description: ["Ukuran ramah anak dengan material lembut dan motif ceria."],
    detail: ["Child-friendly size", "Soft touch", "Anti-slip backing"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Motif dan warna dapat sedikit berbeda dari foto.",
    category: "sajadah",
  },
  {
    slug: "sajadah-sufi-mimbar",
    title: "Sajadah Sufi Mimbar",
    price: "RM105",
    location: "Penang",
    image: sajadah9,
    gallery: [sajadah9, sajadah1, sajadah5],
    description: ["Sajadah tebal motif mimbar dengan tekstur lembut dan detail kaya."],
    detail: ["Soft pile surface", "Anti-slip backing", "Size 35 x 60 cm"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Sedikit perbedaan warna bisa terjadi karena pencahayaan.",
    category: "sajadah",
  },
  {
    slug: "sajadah-baghdad-pattern",
    title: "Sajadah Baghdad Pattern",
    price: "RM115",
    location: "Kuala Lumpur",
    image: sajadah10,
    gallery: [sajadah10, sajadah3, sajadah6],
    description: ["Motif Baghdad dengan finishing premium dan tas serbaguna."],
    detail: ["Premium woven", "Non-slip base", "Include matching pouch"],
    minimumOrder: "Minimum Order: 1 Piece",
    notes: "Warna mungkin sedikit berbeda pada layar perangkat.",
    category: "sajadah",
  },
];

export const findProductBySlug = (slug) =>
  products.find((item) => item.slug === slug);
